// extracted by mini-css-extract-plugin
export default {"footer-espot-container--border":"footer-espot-container--border_jATiP59k"};